module.exports = __webpack_public_path__ + "static/media/Layout5.e1cabbae.png";